export enum Message {
  AwkEditorSave = 'AWK_EDITOR_SAVE',
  CloseEditor = 'CLOSE_EDITOR',
  EditorValue = 'EDITOR_VALUE',
  NotifyOfEditorClose = 'NOTIFY_OF_EDITOR_CLOSE',
  SaveEditorValue = 'SAVE_EDITOR_VALUE',
}
